

export class LanguageOutputWithStatus implements ILanguageOutputWithStatus {
    /** The auto-generated id of the language master */
    language_id!: number;
    /** The language name with 255 character limit */
    language_name!: string;
    /** Manage status of language. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: ILanguageOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language_id = _data["language_id"];
            this.language_name = _data["language_name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): LanguageOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language_id"] = this.language_id;
        data["language_name"] = this.language_name;
        data["status"] = this.status;
        return data; 
    }
}

export interface ILanguageOutputWithStatus {
    /** The auto-generated id of the language master */
    language_id: number;
    /** The language name with 255 character limit */
    language_name: string;
    /** Manage status of language. 0 For De-active, 1 For Active */
    status: number;
}

